import { GridColDef } from '@mui/x-data-grid';
import { Typography } from '@mui/material';

import { JobPosition, routes } from '@carcareers/utils';
import { DataGridLink } from '@carcareers/components';

export const JOB_INDEX_COLUMNS: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 90 },
  {
    field: 'title',
    headerName: 'Job Title',
    width: 200,
    renderCell: (params) => (
      <DataGridLink
        link={`/${routes.EMPLOYER_HOME}/${routes.EMPLOYER_JOBS_VIEW.replace(':id', params.row.id.toString())}`}
        content={params.row.title}
      />
    ),
  },
  {
    field: 'rooftop',
    headerName: 'Rooftop',
    width: 150,
    renderCell: (params) =>
      params.row.rooftop ? (
        <DataGridLink
          link={`/${routes.EMPLOYER_HOME}/${routes.EMPLOYER_ROOFTOPS_VIEW.replace(
            ':id',
            params.row.rooftop?.id.toString(),
          )}`}
          content={params.row.rooftop?.name}
        />
      ) : (
        <Typography variant="body2">-</Typography>
      ),
  },
  {
    field: 'location',
    headerName: 'Address',
    width: 150,
    valueGetter: (_, row) => row.rooftop?.location || '-',
  },
  {
    field: 'description',
    headerName: 'Description',
    width: 150,
  },
  {
    field: 'compensation',
    headerName: 'Compensation',
    width: 150,
    valueGetter: (_, row) =>
      `$${Number(row.compensationMin).toLocaleString()} - $${Number(row.compensationMax).toLocaleString()}`,
  },
  {
    field: 'compensationMin',
    headerName: 'Min Compensation',
    width: 150,
    valueGetter: (_, row) => `$${Number(row.compensationMin).toLocaleString()}`,
  },
  {
    field: 'compensationMax',
    headerName: 'Max Compensation',
    width: 150,
    valueGetter: (_, row) => `$${Number(row.compensationMax).toLocaleString()}`,
  },
  {
    field: 'compensationType',
    headerName: 'Compensation Type',
    width: 150,
    valueGetter: (_, row) => row.compensationType.charAt(0).toUpperCase() + row.compensationType.slice(1),
  },
  {
    field: 'hasCommission',
    headerName: 'Has Commission',
    width: 150,
    valueGetter: (_, row) => (row.hasCommission ? 'Yes' : 'No'),
  },
  {
    field: 'benefits',
    headerName: 'Benefits',
    width: 150,
    valueGetter: (_, row) => row.benefits?.join(', '),
  },
  {
    field: 'keywords',
    headerName: 'Keywords',
    width: 150,
    valueGetter: (_, row) => row.keywords?.join(', '),
  },
  {
    field: 'createdAt',
    headerName: 'Created',
    width: 150,
    valueGetter: (_, row) =>
      new Date(row.createdAt).toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      }),
  },
  {
    field: 'updatedAt',
    headerName: 'Updated',
    width: 150,
    valueGetter: (_, row) =>
      new Date(row.updatedAt).toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      }),
  },
  {
    field: 'lastPostedAt',
    headerName: 'Last Posted',
    width: 150,
    valueGetter: (_, row) =>
      row.posts[0]?.startDate
        ? new Date(row.posts[0]?.startDate).toLocaleString('en-US', {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
          })
        : 'Never',
  },
  {
    field: 'posts',
    headerName: 'Posts',
    width: 150,
    valueGetter: (_, row) => row.posts.length,
  },
];

export const ADMIN_JOB_INDEX_COLUMNS: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 90 },
  {
    field: 'title',
    headerName: 'Job Title',
    width: 200,
    renderCell: (params) => (
      <DataGridLink
        link={`/${routes.ADMIN_HOME}/${routes.ADMIN_JOBS_VIEW.replace(':id', params.row.id.toString())}`}
        content={params.row.title}
      />
    ),
  },
  {
    field: 'rooftop',
    headerName: 'Rooftop',
    width: 150,
    renderCell: (params) =>
      params.row.rooftop ? (
        <DataGridLink
          link={`/${routes.ADMIN_HOME}/${routes.ADMIN_ROOFTOPS_VIEW.replace(':id', params.row.rooftop?.id.toString())}`}
          content={params.row.rooftop?.name}
        />
      ) : (
        <Typography variant="body2">-</Typography>
      ),
  },
  {
    field: 'location',
    headerName: 'Address',
    width: 150,
    valueGetter: (_, row) => row.rooftop?.location || '-',
  },
  {
    field: 'description',
    headerName: 'Description',
    width: 150,
  },
  {
    field: 'compensation',
    headerName: 'Compensation',
    width: 150,
    valueGetter: (_, row) =>
      `$${Number(row.compensationMin).toLocaleString()} - $${Number(row.compensationMax).toLocaleString()}`,
  },
  {
    field: 'compensationMin',
    headerName: 'Min Compensation',
    width: 150,
    valueGetter: (_, row) => `$${Number(row.compensationMin).toLocaleString()}`,
  },
  {
    field: 'compensationMax',
    headerName: 'Max Compensation',
    width: 150,
    valueGetter: (_, row) => `$${Number(row.compensationMax).toLocaleString()}`,
  },
  {
    field: 'compensationType',
    headerName: 'Compensation Type',
    width: 150,
    valueGetter: (_, row) => row.compensationType.charAt(0).toUpperCase() + row.compensationType.slice(1),
  },
  {
    field: 'hasCommission',
    headerName: 'Has Commission',
    width: 150,
    valueGetter: (_, row) => (row.hasCommission ? 'Yes' : 'No'),
  },
  {
    field: 'benefits',
    headerName: 'Benefits',
    width: 150,
    valueGetter: (_, row) => row.benefits?.join(', '),
  },
  {
    field: 'keywords',
    headerName: 'Keywords',
    width: 150,
    valueGetter: (_, row) => row.keywords?.join(', '),
  },
  {
    field: 'createdAt',
    headerName: 'Created',
    width: 150,
    valueGetter: (_, row) =>
      new Date(row.createdAt).toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      }),
  },
  {
    field: 'updatedAt',
    headerName: 'Updated',
    width: 150,
    valueGetter: (_, row) =>
      new Date(row.updatedAt).toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      }),
  },
  {
    field: 'lastPostedAt',
    headerName: 'Last Posted',
    width: 150,
    valueGetter: (_, row) =>
      row.posts[0]?.startDate
        ? new Date(row.posts[0]?.startDate).toLocaleString('en-US', {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
          })
        : 'Never',
  },
  {
    field: 'posts',
    headerName: 'Posts',
    width: 150,
    valueGetter: (_, row) => row.posts.length,
  },
];

export const JOB_INDEX_COLUMN_INITIAL_STATE = {
  id: true,
  title: true,
  rooftop: true,
  location: true,
  description: false,
  compensation: true,
  compensationMin: false,
  compensationMax: false,
  compensationType: true,
  hasCommission: false,
  benefits: false,
  keywords: false,
  posts: false,
  lastPostedAt: true,
  createdAt: false,
  updatedAt: false,
};

export const KEYWORDS = [
  'Sales',
  'Sales Representative',
  'Sales Consultant',
  'New Vehicle Sales',
  'Used Vehicle Sales',
  'Sales Manager',
  'New Car Manager',
  'Used Car Manager',
  'General Sales Manager',
  'GSM',
  'General Manager',
  'GM',
  'Store Manager',
  'F&I Manager',
  'Finance Manager',
  'Business Development Manager',
  'BDC Manager',
  'BDC Representative (Business Development Center)',
  'Business Development/BDC',
  'Internet Sales',
  'Marketing Manager',
  'Customer Service Representative',
  'Customer Service',
  'Lot Attendant',
  'Inventory Control Specialist',
  'Automotive Repair',
  'Mechanic',
  'Technician',
  'Service Technician',
  'Reconditioning Technician',
  'Lube Technician',
  'Oil Technician',
  'Tire Technician',
  'Express Technician',
  'Maintenance Technician',
  'Service Advisor',
  'Service Writer',
  'Service Manager',
  'Service & Parts Director',
  'Fixed Operations Director',
  'Shop Foreman',
  'Cashier',
  'Porter',
  'Service Valet',
  'Detailer',
  'Warranty Administrator',
  'Detailing Supervisor',
  'Diesel Service Technician',
  'Diesel Technician',
  'Diesel Mechanic',
  'Small Engine Diesel Technician',
  'Small Engine Diesel Mechanic',
  'Light Duty Diesel',
  'Heavy Duty Diesel',
  'Heavy Equipment Mechanic',
  'Fleet Mechanic',
  'Fleet Maintenance Mechanic',
  'Mobile Mechanic',
  'Marine Diesel Technician',
  'Parts Counter',
  'Parts Counter Person',
  'Parts Manager',
  'Auto Parts',
  'Automotive Parts',
  'Shipping & Receiving Clerk',
  'Parts Driver',
  'Human Resources',
  'Manufacturing',
  'Production Associate',
  'Production Operator',
  'Machine Operator',
  'Assembly Line Worker',
  'Assembler',
  'Fabricator',
  'Welder',
  'Industrial Maintenance Technician',
  'Industrial Mechanic',
  'Electrical Technician',
  'Millwright',
  'Quality Inspector',
  'Quality Control Inspector',
  'Quality Technician',
  'Quality Engineer',
  'Forklift Operator',
  'Material Handler',
  'Inventory Control Specialist',
  'Manufacturing Engineer',
  'Process Engineer',
  'Industrial Engineer',
  'Production Supervisor',
  'Production Manager',
  'Body Shop',
  'Collision Center',
  'Auto Body Repair',
  'Body Shop Manager',
  'Body Technician',
  'Body Tech',
  'Paint Technician',
  'Finish Detailer',
  'Estimator',
  'Body Shop Estimator',
  'CDL Driver',
  'Non-CDL Driver',
  'Driver',
  'Truck Driver',
  'Delivery Driver',
  'Tow Truck Driver',
  'Dispatcher',
  'Controller',
  'Office Manager',
  'Payroll / Accountant',
  'Title Clerk',
  'Biller',
  'Receptionist',
  'Collections',
  'Claims Adjuster',
  'Insurance Adjuster',
];

export const JOB_POSITIONS: JobPosition[] = [
  { department: 'Sales', position: 'Sales' },
  { department: 'Sales', position: 'Sales Representative' },
  { department: 'Sales', position: 'Sales Consultant' },
  { department: 'Sales', position: 'New Vehicle Sales' },
  { department: 'Sales', position: 'Used Vehicle Sales' },
  { department: 'Sales', position: 'Sales Manager' },
  { department: 'Sales', position: 'New Car Manager' },
  { department: 'Sales', position: 'Used Car Manager' },
  { department: 'Sales', position: 'General Sales Manager' },
  { department: 'Sales', position: 'GSM' },
  { department: 'Sales', position: 'General Manager' },
  { department: 'Sales', position: 'GM' },
  { department: 'Sales', position: 'Store Manager' },
  { department: 'Sales', position: 'F&I Manager' },
  { department: 'Sales', position: 'Finance Manager' },
  { department: 'Sales', position: 'Business Development Manager' },
  { department: 'Sales', position: 'BDC Manager' },
  { department: 'Sales', position: 'BDC Representative (Business Development Center)' },
  { department: 'Sales', position: 'Business Development/BDC' },
  { department: 'Sales', position: 'Internet Sales' },
  { department: 'Sales', position: 'Marketing Manager' },
  { department: 'Sales', position: 'Customer Service Representative' },
  { department: 'Sales', position: 'Customer Service' },
  { department: 'Sales', position: 'Lot Attendant' },
  { department: 'Sales', position: 'Inventory Control Specialist' },

  { department: 'Service', position: 'Automotive Repair' },
  { department: 'Service', position: 'Mechanic' },
  { department: 'Service', position: 'Technician' },
  { department: 'Service', position: 'Service Technician' },
  { department: 'Service', position: 'Reconditioning Technician' },
  { department: 'Service', position: 'Lube Technician' },
  { department: 'Service', position: 'Oil Technician' },
  { department: 'Service', position: 'Tire Technician' },
  { department: 'Service', position: 'Express Technician' },
  { department: 'Service', position: 'Maintenance Technician' },
  { department: 'Service', position: 'Service Advisor' },
  { department: 'Service', position: 'Service Writer' },
  { department: 'Service', position: 'Service Manager' },
  { department: 'Service', position: 'Service & Parts Director' },
  { department: 'Service', position: 'Fixed Operations Director' },
  { department: 'Service', position: 'Shop Foreman' },
  { department: 'Service', position: 'Cashier' },
  { department: 'Service', position: 'Porter' },
  { department: 'Service', position: 'Service Valet' },
  { department: 'Service', position: 'Detailer' },
  { department: 'Service', position: 'Warranty Administrator' },
  { department: 'Service', position: 'Detailing Supervisor' },
  { department: 'Service', position: 'Diesel Service Technician' },
  { department: 'Service', position: 'Diesel Technician' },
  { department: 'Service', position: 'Diesel Mechanic' },
  { department: 'Service', position: 'Small Engine Diesel Technician' },
  { department: 'Service', position: 'Small Engine Diesel Mechanic' },
  { department: 'Service', position: 'Light Duty Diesel' },
  { department: 'Service', position: 'Heavy Duty Diesel' },
  { department: 'Service', position: 'Heavy Equipment Mechanic' },
  { department: 'Service', position: 'Fleet Mechanic' },
  { department: 'Service', position: 'Fleet Maintenance Mechanic' },
  { department: 'Service', position: 'Mobile Mechanic' },
  { department: 'Service', position: 'Marine Diesel Technician' },

  { department: 'Parts', position: 'Parts Counter' },
  { department: 'Parts', position: 'Parts Counter Person' },
  { department: 'Parts', position: 'Parts Manager' },
  { department: 'Parts', position: 'Auto Parts' },
  { department: 'Parts', position: 'Automotive Parts' },
  { department: 'Parts', position: 'Shipping & Receiving Clerk' },
  { department: 'Parts', position: 'Parts Driver' },

  { department: 'Human Resources', position: 'Human Resources' },

  { department: 'Manufacturing', position: 'Manufacturing' },
  { department: 'Manufacturing', position: 'Production Associate' },
  { department: 'Manufacturing', position: 'Production Operator' },
  { department: 'Manufacturing', position: 'Machine Operator' },
  { department: 'Manufacturing', position: 'Assembly Line Worker' },
  { department: 'Manufacturing', position: 'Assembler' },
  { department: 'Manufacturing', position: 'Fabricator' },
  { department: 'Manufacturing', position: 'Welder' },
  { department: 'Manufacturing', position: 'Industrial Maintenance Technician' },
  { department: 'Manufacturing', position: 'Industrial Mechanic' },
  { department: 'Manufacturing', position: 'Electrical Technician' },
  { department: 'Manufacturing', position: 'Millwright' },
  { department: 'Manufacturing', position: 'Quality Inspector' },
  { department: 'Manufacturing', position: 'Quality Control Inspector' },
  { department: 'Manufacturing', position: 'Quality Technician' },
  { department: 'Manufacturing', position: 'Quality Engineer' },
  { department: 'Manufacturing', position: 'Forklift Operator' },
  { department: 'Manufacturing', position: 'Material Handler' },
  { department: 'Manufacturing', position: 'Inventory Control Specialist' },
  { department: 'Manufacturing', position: 'Manufacturing Engineer' },
  { department: 'Manufacturing', position: 'Process Engineer' },
  { department: 'Manufacturing', position: 'Industrial Engineer' },
  { department: 'Manufacturing', position: 'Production Supervisor' },
  { department: 'Manufacturing', position: 'Production Manager' },

  { department: 'Body Shop', position: 'Body Shop' },
  { department: 'Body Shop', position: 'Collision Center' },
  { department: 'Body Shop', position: 'Auto Body Repair' },
  { department: 'Body Shop', position: 'Body Shop Manager' },
  { department: 'Body Shop', position: 'Body Technician' },
  { department: 'Body Shop', position: 'Body Tech' },
  { department: 'Body Shop', position: 'Paint Technician' },
  { department: 'Body Shop', position: 'Finish Detailer' },
  { department: 'Body Shop', position: 'Estimator' },
  { department: 'Body Shop', position: 'Body Shop Estimator' },

  { department: 'Drivers', position: 'CDL Driver' },
  { department: 'Drivers', position: 'Non-CDL Driver' },
  { department: 'Drivers', position: 'Driver' },
  { department: 'Drivers', position: 'Truck Driver' },
  { department: 'Drivers', position: 'Delivery Driver' },
  { department: 'Drivers', position: 'Tow Truck Driver' },
  { department: 'Drivers', position: 'Dispatcher' },

  { department: 'Administration', position: 'Controller' },
  { department: 'Administration', position: 'Office Manager' },
  { department: 'Administration', position: 'Payroll / Accountant' },
  { department: 'Administration', position: 'Title Clerk' },
  { department: 'Administration', position: 'Biller' },
  { department: 'Administration', position: 'Receptionist' },
  { department: 'Administration', position: 'Cashier' },
  { department: 'Administration', position: 'Collections' },
  { department: 'Administration', position: 'Claims Adjuster' },
  { department: 'Administration', position: 'Insurance Adjuster' },
];

export const COMMITMENT_TYPES = [
  { value: 'fullTime', label: 'Full Time' },
  { value: 'partTime', label: 'Part Time' },
  { value: 'contract', label: 'Contract' },
  { value: 'temporary', label: 'Temporary' },
  { value: 'seasonal', label: 'Seasonal' },
];

export const BENEFITS = [
  { name: 'Remote', value: 'remote' },
  { name: 'On-site', value: 'on-site' },
  { name: 'Hybrid', value: 'hybrid' },
  { name: 'Medical', value: 'medical' },
  { name: 'Dental', value: 'dental' },
  { name: 'Vision', value: 'vision' },
  { name: 'Retirement 401k', value: 'retirement401k' },
  { name: 'Life Insurance', value: 'lifeInsurance' },
  { name: 'Paid Time Off', value: 'paidTimeOff' },
  { name: 'Tuition Reimbursement', value: 'tuitionReimbursement' },
  { name: 'Paid Training', value: 'paidTraining' },
  { name: 'Company Vehicle', value: 'companyVehicle' },
  { name: 'Company Phone', value: 'companyPhone' },
  { name: 'Employee Discounts', value: 'employeeDiscounts' },
];

// 'SALES': [
//   'New Vehicle Sales',
//   'Used Vehicle Sales',
//   'New Car Manager',
//   'Used Car Manager',
//   'General Sales Manager',
//   'F&I Manager',
// ],
// 'SERVICE': [
//   'Technician',
//   'Service Advisor',
//   'Service Manager',
//   'Cashier',
//   'Porter',
//   'Detailer',
// ],
// 'PARTS': [
//   'Parts Counter',
//   'Parts Manager',
// ],
// 'HUMAN_RESOURCES': [
//   'Human Resources',
// ],
// 'MANUFACTURING': [
//   'Manufacturing',
// ],
// 'BODY_SHOP': [
//   'Body Shop',
// ],
// 'DRIVERS': [
//   'CDL Drivers',
//   'Non CDL Drivers',
// ],
// 'ADMINISTRATION': [
//   'Controller',
//   'Payroll / Accountant',
//   'Title Clerk',
//   'Biller',
//   'Receptionist',
//   'Cashier',
// ],
